export const objectFormat = (obj) => {
  let o = {}

  let Blacklist = ['createTime','updateTime']
  Object.keys(obj).filter(item=>{
    if(typeof obj[item] != 'object' && Blacklist.indexOf(item) == -1){
      if(item == 'password'){
        if(obj[item].length < 18) o[item] = obj[item]
      }else{
        o[item] = obj[item]
      }
    }
  })
  return o
}

export const joinArray = (arr) =>{ // 数组分割字符串
  return arr.join(',')
}

export const _ToHump = (jsons) => {
    let str = jsons
    var re = /_(\w)/g;
    str = str.replace(re, function($0, $1) {
      return $1.toUpperCase();
    });
    return str
}
